import { Loader2 } from 'lucide-react';
import type { OcrSubmission } from '@/stores/useOcrSubmissionStore';

export function OcrSubmissionProgressWidget({ submission }: { submission: OcrSubmission }) {
  const storing = submission.phase === 'storing';
  const label = storing ? '서버 저장 중' : '파일 업로드 중';
  return (
    <section role="status" aria-label="시험지 읽기 준비" className="fixed bottom-44 right-4 z-40 w-[calc(100vw-2rem)] max-w-xs overflow-hidden rounded-xl border-2 border-amber-200 bg-white shadow-lg md:bottom-24 md:w-80">
      <div className="flex items-start gap-3 border-b border-forest-200 bg-amber-50 p-4">
        <Loader2 aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 animate-spin text-amber-600" />
        <div className="min-w-0">
          <h3 className="font-bold text-forest-900">시험지 읽기 준비 중</h3>
          <p className="truncate text-sm text-forest-600" title={submission.filename}>{submission.filename}</p>
        </div>
      </div>
      <div className="space-y-3 p-4">
        <div className="flex justify-between text-sm font-semibold text-forest-800">
          <span>{label}</span>
          {!storing && submission.percentage != null && <span>{submission.percentage}%</span>}
        </div>
        <div role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={100}
          aria-valuenow={!storing && submission.percentage != null ? submission.percentage : undefined}
          className="h-2.5 overflow-hidden rounded-full bg-gray-200">
          <div className={`h-full rounded-full bg-amber-500 ${storing || submission.percentage == null ? 'w-1/3 animate-pulse' : ''}`}
            style={!storing && submission.percentage != null ? { width: `${submission.percentage}%` } : undefined} />
        </div>
        <p className="text-sm text-forest-600">{storing ? '파일을 저장하고 있습니다. 완료되면 자동으로 시험지를 읽습니다.' : '시험지 파일을 보내고 있습니다.'}</p>
      </div>
    </section>
  );
}
